<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i> 諸届一覧</span>
        </div>
        <div class="card-body">
          <div style="height: 1px"></div>
          <div class="col-md-12">
            <!-- 区分コース -->
            <div class="form-group row">
              <div class="col-3 d-flex align-items-center justify-content-start col-md-1 text-break text-white p-2"
                   [class.bg-primary]="notification.plan?.status != 0 && notification.plan?.status != 1"
                   [class.bg-warning]="notification.plan?.status == 0"
                   [class.bg-success]="notification.plan?.status == 1">
                @if (notification.plan) {
                  <div class="d-flex flex-column bd-highlight text-center">
                    @if (notification.plan.status == 0) { <span title="申請中"><i class="fa s-icon-schedule fa-2x fa-fw"></i></span><small>申請中</small> }
                    @if (notification.plan.status == 1) { <span title="確認中"><i class="fa s-icon-schedule fa-2x fa-fw"></i></span><small>確認中</small> }
                    @if (notification.plan.status == 2) { <span title="確認済"><i class="fa s-icon-finished fa-2x fa-fw"></i></span><small>確認済</small> }
                  </div>
                }
              </div>
              <div class="col-9 col-md-3 d-flex align-items-center text-white p-2"
                   [class.bg-primary]="notification.plan?.status != 0 && notification.plan?.status != 1"
                   [class.bg-warning]="notification.plan?.status == 0"
                   [class.bg-success]="notification.plan?.status == 1">
                <label class="col-form-label d-flex align-items-center"><i class="fa s-icon-plans fa-2x mr-2"></i><span> 区分コース</span></label>
              </div>
              <div class="col-9 col-md-7 d-flex align-items-center border border-right-0 border-primary p-2"
                   [class.border-warning]="notification.plan?.status == 0"
                   [class.border-success]="notification.plan?.status == 1">
                <div>
                  <label class="col-form-label">
                    <span> {{ member.studioPlan?.name }}</span>
                    @if (notification.plan) {
                      <span class="d-md-inline-block d-none">&emsp;※{{ notification.plan.afterStudioPlan?.name }}&#040;{{ formatDate(notification.plan.startDate, 'yyyy年MM月') }}～&#041;</span>
                    }
                  </label>
                  @if (notification.plan) {
                    <label class="col-form-label d-inline-block d-md-none pt-0">
                      <span>※{{ notification.plan.afterStudioPlan?.name }}&#040;{{ formatDate(notification.plan.startDate, 'yyyy年MM月') }}～&#041;</span>
                    </label>
                  }
                </div>
              </div>
              <div class="col-3 col-md-1 d-flex justify-content-end align-items-center border border-left-0 border-primary p-2"
                   [class.border-warning]="notification.plan?.status == 0"
                   [class.border-success]="notification.plan?.status == 1">
                <button type="button" class="btn btn-blue text-white" title="区分コース申請" routerLink="/notification/plan" [disabled]="!!notification.plan"><i class="fa s-icon-edit"></i></button>
              </div>
            </div>

            <!-- 支払方法 -->
            <div class="form-group row">
              <div class="col-3 d-flex align-items-center justify-content-start col-md-1 text-break text-white p-2"
                   [class.bg-primary]="notification.payment?.status != 0 && notification.payment?.status != 1"
                   [class.bg-warning]="notification.payment?.status == 0"
                   [class.bg-success]="notification.payment?.status == 1">
                @if (notification.payment) {
                  <div class="d-flex flex-column bd-highlight text-center">
                    @if (notification.payment.status == 0) { <span title="申請中"><i class="fa s-icon-schedule fa-2x fa-fw"></i></span><small>申請中</small> }
                    @if (notification.payment.status == 1) { <span title="確認中"><i class="fa s-icon-schedule fa-2x fa-fw"></i></span><small>確認中</small> }
                    @if (notification.payment.status == 2) { <span title="確認済"><i class="fa s-icon-finished fa-2x fa-fw"></i></span><small>確認済</small> }
                  </div>
                }
              </div>
              <div class="col-9 col-md-3 d-flex align-items-center text-white p-2"
                   [class.bg-primary]="notification.payment?.status != 0 && notification.payment?.status != 1"
                   [class.bg-warning]="notification.payment?.status == 0"
                   [class.bg-success]="notification.payment?.status == 1">
                <label class="col-form-label d-flex align-items-center"><i class="fa s-icon-method fa-2x mr-2"></i><span> 支払方法</span></label>
              </div>
              <div class="col-9 col-md-7 d-flex align-items-center border border-right-0 border-primary p-2"
                   [class.border-warning]="notification.payment?.status == 0"
                   [class.border-success]="notification.payment?.status == 1">
                <div>
                  <label class="col-form-label">
                    @if (member.payment?.paymentMethod == 0) { <span> 口座振替</span> }
                    @if (member.payment?.paymentMethod == 1) { <span> クレジットカード</span> }
                    @if (notification.payment?.afterPaymentMethod == 0) {
                      <span class="d-md-inline-block d-none">&emsp;※口座振替&#040;{{ formatDate(notification.payment.startDate, 'yyyy年MM月') }}末～&#041;</span>
                    }
                    @if (notification.payment?.afterPaymentMethod == 1) {
                      <span class="d-md-inline-block d-none">&emsp;※クレジットカード&#040;{{ formatDate(notification.payment.startDate, 'yyyy年MM月dd日') }}～&#041;</span>
                    }
                  </label>
                  <label class="col-form-label d-inline-block d-md-none pt-0">
                    @if (notification.payment?.afterPaymentMethod == 0) {
                      <span>&emsp;※口座振替&#040;{{ formatDate(notification.payment.startDate, 'yyyy年MM月') }}末～&#041;</span>
                    }
                    @if (notification.payment?.afterPaymentMethod == 1) {
                      <span>&emsp;※クレジットカード&#040;{{ formatDate(notification.payment.startDate, 'yyyy年MM月dd日') }}～&#041;</span>
                    }
                  </label>
                </div>
              </div>
              <div class="col-3 col-md-1 d-flex justify-content-end align-items-center border border-left-0 border-primary p-2"
                   [class.border-warning]="notification.payment?.status == 0"
                   [class.border-success]="notification.payment?.status == 1">
                <button type="button" class="btn btn-blue text-white" title="支払方法申請" routerLink="/notification/payment"><i class="fa s-icon-edit"></i></button>
              </div>
            </div>

            <div class="row">
              <div class="col-12 form-group">
                <span>※マイページからの諸届申請の締切日は9日までとなってございます。</span>
              </div>
              <div class="col-12 form-group">
                <span>※お支払方法の変更・更新は「クレジットカード」または「口座振替（対応店舗のみ）」となります。</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
